module.exports = __webpack_public_path__ + "media/headers/preguntas_frecuentes-b1251a72.png";